export default (state = [], action) => {
    switch (action.type) {
        case "SET_MANAGER_SUCCESS":
            return [...action.manager, ...state]

        default:
            return state;
    }
}